import { render } from "./SubscriptionLegalFooter.vue.js?vue&type=template&id=0941a760!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SubscriptionLegalFooter.vue?vue&type=template&id=0941a760"
import script from "./SubscriptionLegalFooter.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SubscriptionLegalFooter.vue?vue&type=script&lang=js"
export * from "./SubscriptionLegalFooter.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SubscriptionLegalFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/plan-sheet/SubscriptionLegalFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0941a760"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0941a760', __exports__)) {
    api.reload('0941a760', __exports__)
  }
  
  module.hot.accept("./SubscriptionLegalFooter.vue.js?vue&type=template&id=0941a760!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SubscriptionLegalFooter.vue?vue&type=template&id=0941a760", () => {
    api.rerender('0941a760', render)
  })

}


export default __exports__